import { gql } from '@lcs/shared/api';

export const getUsersQuery = gql`
   query GetUsers($first: Int!, $filters: String, $after: String, $orderingOptions: [OrderingOption!]) {
      usersConnection(first: $first, filters: $filters, after: $after, orderingOptions: $orderingOptions) {
         totalCount
         pageInfo {
            hasNextPage
            endCursor
            hasPreviousPage
            startCursor
         }
         items {
            userId
            name
            username
            emailAddress
            isActive
            lastLoggedIn
            isLocked
         }
      }
   }
`;
